import endpoints from 'shared/store/endpoints'
import { ws } from 'shared/store/ws'
import { useQuery } from '@tanstack/react-query'

export const useStudentProfileChoices = (options?: any) => {
    return useQuery({
        queryKey: ['student-profile-choices'],
        queryFn: async () => {
            const result = await ws.get(
                endpoints.kingdom.profile.student.choices
            )
            return result.data
        },
        ...options
    })
}
